import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const SidebarToggle = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function SidebarToggle({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 4.75C2.86193 4.75 2.75 4.86193 2.75 5V19C2.75 19.1381 2.86193 19.25 3 19.25H9.25V4.75H3ZM10.75 4.75V19.25H21C21.1381 19.25 21.25 19.1381 21.25 19V5C21.25 4.86193 21.1381 4.75 21 4.75H10.75ZM1.25 5C1.25 4.0335 2.0335 3.25 3 3.25H21C21.9665 3.25 22.75 4.0335 22.75 5V19C22.75 19.9665 21.9665 20.75 21 20.75H3C2.0335 20.75 1.25 19.9665 1.25 19V5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 7.75C4 7.47386 4.22386 7.25 4.5 7.25H7.5C7.77614 7.25 8 7.47386 8 7.75V8.25C8 8.52614 7.77614 8.75 7.5 8.75H4.5C4.22386 8.75 4 8.52614 4 8.25V7.75ZM4 11.75C4 11.4739 4.22386 11.25 4.5 11.25H7.5C7.77614 11.25 8 11.4739 8 11.75V12.25C8 12.5261 7.77614 12.75 7.5 12.75H4.5C4.22386 12.75 4 12.5261 4 12.25V11.75ZM8 16.25C8 16.5261 7.77614 16.75 7.5 16.75H4.5C4.22386 16.75 4 16.5261 4 16.25V15.75C4 15.4739 4.22386 15.25 4.5 15.25H7.5C7.77614 15.25 8 15.4739 8 15.75V16.25Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'sidebar-toggle-icon-svg'} iconRender={iconRender} {...props} />;
});

export default SidebarToggle;
